import { FeaturedTestimonyPublicationStatus } from '../../enums/publication-status.enums';
import { FiltersFormValue, QueryData } from '../query-data.payload';
import { FileFormValue } from '../file.payload';
import { AbstractTestimonyFormValue, AbstractTestimonyPayload } from './abstract-testimony.payload';

export interface FeaturedTestimonyFormValue extends AbstractTestimonyFormValue {
  firstName: string;
  rank: number;
  quote: string;
  picture: FileFormValue;
}

export class UpdateFeaturedTestimonyPayload extends AbstractTestimonyPayload {
  firstName: string;
  rank: number;
  quote: string;

  constructor(formValue: Partial<FeaturedTestimonyFormValue>) {
    super(formValue);
    this.firstName = formValue.firstName;
    this.rank = Number(formValue.rank);
    this.quote = formValue.quote;
  }
}

export class AddFeaturedTestimonyPayload extends UpdateFeaturedTestimonyPayload {
  picture: File;

  constructor(formValue: Partial<FeaturedTestimonyFormValue>) {
    super(formValue);
    this.picture = formValue.picture.file;
  }
}

export class UpdateFeaturedTestimonyPicturePayload {
  file: File;

  constructor(formValue: Partial<FeaturedTestimonyFormValue>) {
    this.file = formValue.picture.file;
  }
}

export interface FeaturedTestimonyFiltersFormValue extends FiltersFormValue {
  publicationStatus: FeaturedTestimonyPublicationStatus[];
}

export class FeaturedTestimonyQueryData extends QueryData {
  publicationStatus: string;

  constructor(filtersFormValue: FeaturedTestimonyFiltersFormValue) {
    super(filtersFormValue, true);
    if (filtersFormValue.publicationStatus)
      this.publicationStatus = filtersFormValue.publicationStatus.join(',');
  }
}

export interface WFeaturedTestimonyFiltersFormValue extends FiltersFormValue {
  publicationStatus?: FeaturedTestimonyPublicationStatus;
}

export class WFeaturedTestimonyQueryData extends QueryData {
  publicationStatus?: FeaturedTestimonyPublicationStatus;

  constructor(filtersFormValue: WFeaturedTestimonyFiltersFormValue) {
    super(filtersFormValue);
    this.publicationStatus = filtersFormValue.publicationStatus;
  }
}
